import { createAction, createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import loader, { Loader } from '@ott/utility-loader';
import superagent from '@ott/superagent';
import _noop from 'lodash/noop';

import { Destination, RenderContext } from '../../types';
import { DEFAULT_HAPI_BASE_URL } from '../../constants';
import prepareResponse from '../utilities/prepareResponse';
import getMainLocaleParams from '../../utilities/getMainLocaleParams';

interface State {
  statuses: Loader;
  data: Destination[];
}

const initialState: State = {
  statuses: loader.initial(),
  data: [],
};

interface ActionParams {
  hapi?: string;
  requested: string;
  context: RenderContext;
}

let promise: any;

export const fetchSuggests = createAsyncThunk<
  Destination[],
  ActionParams,
  { rejectValue: unknown }
>('suggests/fetch', async ({ hapi, requested }, { rejectWithValue }) => {
  const url = `${hapi || DEFAULT_HAPI_BASE_URL}/v3/suggestRequest`;
  const mainLocaleParams = getMainLocaleParams();

  try {
    if (promise) {
      promise.abort();
    }

    promise = superagent
      .get(url)
      .query({
        ...mainLocaleParams,
        query: requested,
      })
      .withCredentials();

    const { body } = await promise;

    return prepareResponse(body?.result || []);
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const resetSuggests = createAction('suggests/reset');
export const trackEmptySuggests = createAction('suggests/trackEmpty');

const suggestsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchSuggests.pending, (state) => {
      state.statuses = loader.begin();
    })
    .addCase(fetchSuggests.fulfilled, (state, { payload }) => {
      state.statuses = loader.success();
      state.data = payload;
    })
    .addCase(fetchSuggests.rejected, (state) => {
      state.statuses = loader.error();
    })
    .addCase(resetSuggests, () => initialState);
});

export default suggestsReducer;

export const actions = {
  fetch: fetchSuggests,
  reset: resetSuggests,
  trackEmptySuggests,
};
